import fallbackImage from '../assets/images/infite_logo.png';

export function imageResolver(imgSrc) {
	if (!imgSrc) return fallbackImage;

	return imgSrc.includes('NoPhotoAvailable.jpg') ? fallbackImage : `http:${imgSrc}`;
}
